/* eslint-disable react/jsx-no-bind */
import React, { useContext, useEffect, useState } from 'react';
import './language.css';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SquareRadio from '../../components/Radio/SquareRadio';
import En from '../../assets/designSystem/icons/United Kingdom.svg';
import Swa from '../../assets/designSystem/icons/Kenya.svg';
import Warning from '../../assets/designSystem/icons/hazard.svg';
import Button from '../../components/Button/Button';
import MetricsContext from '../../context/MetricsContext';
import PageNames from '../../utils/PageNames';
import PageTypes from '../../utils/PageTypes';
import Emergency from '../../components/Emergency/Emergency';

export default function Language() {
  const navigate = useNavigate();
  const [activeBtn, setActiveBtn] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [language, setLanguage] = useState();
  const startDate = new Date();

  const { i18n, t } = useTranslation();

  const { updateUserMetric, storeLocalMetrics } = useContext(MetricsContext);

  const sessionId = localStorage.getItem('sessionId');

  useEffect(() => {
    if (sessionId) {
      updateUserMetric({
        name: PageNames.LANGUAGE_PAGE,
        pageType: PageTypes.DEFAULT,
      });
    } else {
      storeLocalMetrics({
        name: PageNames.LANGUAGE_PAGE,
        pageType: PageTypes.DEFAULT,
      });
    }
  }, [sessionId]);

  function handleRedirect() {
    const dateFinal = new Date();
    if (sessionId) {
      updateUserMetric({
        name: PageNames.LANGUAGE_PAGE,
        pageType: PageTypes.DEFAULT,
        duration: Math.abs(dateFinal - startDate),
        interactions: [
          {
            name: language,
            time: dateFinal,
          },
        ],
      });
    } else {
      storeLocalMetrics({
        name: PageNames.LANGUAGE_PAGE,
        pageType: PageTypes.DEFAULT,
        duration: Math.abs(dateFinal - startDate),
        interactions: [
          {
            name: language,
            time: dateFinal,
          },
        ],
      });
    }
    navigate('/agreement');
  }

  function handleClick(e) {
    if (e.target.value !== '') {
      setActiveBtn(false);
      setLanguage(e.target.value);
      i18n.changeLanguage(e.target.value);
    }
  }

  function handleEmergencyClick() {
    const dateFinal = new Date();
    updateUserMetric({
      name: PageNames.EMERGENCY_CONTACTS_MODAL,
      pageType: PageTypes.DEFAULT,
      duration: Math.abs(dateFinal - startDate),
      interactions: [
        {
          name: 'emergency',
          time: dateFinal,
        },
      ],
    });
    setShowModal(true);
  }

  return (
    <div className="container">
      <div className="containerContent language__page">
        <div>
          <h3 className="language__center">{t('languagepage.start')}</h3>
          <p className="language__paragraph">{t('languagepage.selectlang')}</p>
          <div id="test" className="language__radios">
            <SquareRadio name="option" image={En} label="English" value="English" onClick={handleClick} />
            <SquareRadio name="option" image={Swa} label="Swahili" value="Swahili" onClick={handleClick} />
          </div>
        </div>
        <div className="language__warning">
          <div className="language__warning__container">
            <img src={Warning} className="language__warning__image" alt="Warning" width={20} height={20} />
            <p className="language__warning_description">{t('disclaimer.p1')}</p>
          </div>
          <ul>
            <li>{t('disclaimer.l1')}</li>
            <li>{t('disclaimer.l2')}</li>
            <li>{t('disclaimer.l3')}</li>
          </ul>
          <p className="language__warning_description">{t('disclaimer.p2')}</p>
        </div>
        <div className="language__page__button">
          <Button
            hierarchy="primary"
            width="fullWidth"
            disabled={activeBtn}
            onClick={handleRedirect}
            additionalClass=" continue"
          >
            {t('continue')}
          </Button>
          <Button hierarchy="destructive" width="fullWidth" onClick={handleEmergencyClick} additionalClass=" emergency">
            {t('emergency.button')}
          </Button>
        </div>
      </div>
      {showModal && <Emergency onCloseModal={() => setShowModal(false)} />}
    </div>
  );
}
